import React from 'react';
import { Trans } from '@lingui/macro';
import { Typography } from 'antd';
import clsx from 'clsx';

import { CheckIcon } from './icons';

export interface CopyLinkProps {
  type?: 'primary' | 'default';
  copyText?: string;
  icon?: React.ReactElement;
  iconSize?: number;
  label?: React.ReactElement | string | null;
}

const { Text } = Typography;

export const CopyLink: React.FC<CopyLinkProps> = ({
  type = 'default',
  copyText,
  iconSize = 24,
  icon = (
    <i className="material-icons" style={{ fontSize: iconSize }}>
      content_copy
    </i>
  ),
  label = <Trans id="general.copy">copy</Trans>,
}) => {
  const className = type === 'primary' ? 'g-color-emphasis' : '';

  return (
    <Text
      copyable={{
        text: copyText,
        icon: [
          <Link
            key="copy"
            className={className}
            label={label}
            iconSize={iconSize}
            icon={icon}
          />,
          <Link
            key="copied"
            className={className}
            label={label}
            iconSize={iconSize}
            icon={
              <div
                style={{
                  display: 'inline-block',
                  width: iconSize,
                  height: iconSize,
                  lineHeight: 1,
                }}
              >
                <CheckIcon style={{ fontSize: iconSize, color: '#52c41a' }} />
              </div>
            }
          />,
        ],
      }}
    />
  );
};

const Link: React.FC<{
  className?: string;
  icon: React.ReactElement;
  label: React.ReactElement | string | null;
  iconSize: number;
}> = ({ className, icon, label, iconSize }) => (
  <a
    className={clsx('b-link -type_underlined', className)}
    href=""
    onClick={(event) => event.preventDefault()}
    style={{ lineHeight: `${iconSize}px`, verticalAlign: 'bottom' }}
  >
    <span>{icon}</span>
    {label && <> {label}</>}
  </a>
);
